import { useEffect, useState } from "react";
import { LogoMark } from "@/components/Logo";

export function SplashScreen() {
  const [visible, setVisible] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const isStandalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      (navigator as any).standalone === true;

    if (!isStandalone) {
      setVisible(false);
      return;
    }

    const hasShownSplash = sessionStorage.getItem("splash-shown");
    if (hasShownSplash) {
      setVisible(false);
      return;
    }

    sessionStorage.setItem("splash-shown", "1");

    const fadeTimer = setTimeout(() => setFadeOut(true), 1200);
    const hideTimer = setTimeout(() => setVisible(false), 1800);

    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(hideTimer);
    };
  }, []);

  if (!visible) return null;

  return (
    <div
      className={`fixed inset-0 z-[200] flex flex-col items-center justify-center bg-white transition-opacity duration-500 ${
        fadeOut ? "opacity-0 pointer-events-none" : "opacity-100"
      }`}
      aria-hidden="true"
    >
      <div className="animate-splash-logo flex flex-col items-center gap-4">
        <LogoMark size={80} />
        <div className="flex items-center gap-1">
          <span className="text-2xl font-bold text-slate-900">Rent</span>
          <span className="text-2xl font-bold bg-gradient-to-r from-primary-600 to-primary-500 bg-clip-text text-transparent">
            Maadi
          </span>
        </div>
      </div>
      <div className="absolute bottom-16">
        <div className="h-1 w-16 overflow-hidden rounded-full bg-slate-100">
          <div className="h-full animate-splash-progress rounded-full bg-gradient-to-r from-primary-500 to-primary-600" />
        </div>
      </div>
    </div>
  );
}
